import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router";
import { useAuth } from "@/auth/AuthProvider";
import { navRoutes } from "@/routes";
import { useSite } from "@/lib/useSite";
import { Avatar, Button, ButtonLink } from "@/components/ui";
import { ThemeToggle } from "./ThemeToggle";
import { UtensilsMenu } from "./UtensilsMenu";

export function SiteHeader() {
  const { user, loading, logout, can } = useAuth();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const links = navRoutes("site", useSite());

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <Link to="/" className="site-header__brand brand-mark" onClick={() => setOpen(false)}>
          <span className="tag">LF</span>
        </Link>

        <nav
          className={`site-header__nav ${open ? "site-header__nav--open" : ""}`}
          aria-label="Main"
        >
          {links
            .filter((route) => route.path !== "/")
            .map((route) => (
              <NavLink
                key={route.path}
                to={route.path}
                className="nav-link"
                onClick={() => setOpen(false)}
              >
                <span className="tag">{route.label}</span>
              </NavLink>
            ))}

          {/* Other tools and apps, editable from Admin → Utensils. This
              replaced a hard-coded list of external links in the nav. */}
          <UtensilsMenu onNavigate={() => setOpen(false)} />
        </nav>

        <div className="row" style={{ gap: "var(--s-2)" }}>
          <ThemeToggle />

          {loading ? null : user ? (
            <>
              {can("admin.access") && (
                <NavLink to="/admin" className="nav-link">
                  <span className="tag">Admin</span>
                </NavLink>
              )}
              <Link to="/dashboard" title={user.email} aria-label="Your dashboard">
                <Avatar name={user.name} email={user.email} src={user.avatarUrl} />
              </Link>
              <Button variant="ghost" size="sm" onClick={() => void logout()}>
                Sign out
              </Button>
            </>
          ) : (
            <ButtonLink
              to={`/login?redirectTo=${encodeURIComponent(location.pathname)}`}
              variant="primary"
              size="sm"
            >
              Sign in
            </ButtonLink>
          )}

          <button
            type="button"
            className="btn btn--ghost btn--icon nav-toggle"
            aria-expanded={open}
            aria-label="Toggle navigation"
            onClick={() => setOpen((v) => !v)}
          >
            <span aria-hidden>{open ? "✕" : "☰"}</span>
          </button>
        </div>
      </div>
    </header>
  );
}
